import PropTypes from 'prop-types'

const SimpleListItem = ({ children }) => (
  <div className={`flex flex-wrap items-center justify-between p-2 border-gray-300 dark:border-content2-foreground border-dotted border-b-1 gap-y-2`}>
    {children}
  </div>
)

SimpleListItem.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SimpleListItem